import React from "react";
import { connect } from "react-redux";
import { Button, TextArea } from "devextreme-react";
import { lastStep, setDataNewComplain, doCreateComplaints } from "../../actions";
import DateField from "../../../../../../Shared/fields/DateField";
import TextField from "../../../../../../Shared/fields/TextField";
import RadioGroupfield from "../../../../../../Shared/fields/RadioGroupField";
// import { VerPDF } from "../../../../../../Pdf/actions";
import { formatDateForFormDenuncia, calculateAge, calculateAgeDays } from "../../../../../../../helpers/dateFormat";
import moment from "moment";

class EnvioDenuncia extends React.PureComponent {
  constructor(props) {
    super(props);
    const jsonData = { ...this.props.jsonData };
    jsonData.horaPresentacion = new Date();
    if (jsonData.formInfoDenuncia.tipoDenuncia.IdTipoDenuncia === "003") {
      const formDatoSiniestro = { ...jsonData.formDatoSiniestro }
      jsonData.formDatoSiniestro.textoCircunstacia = `AL MOMENTO DEL ACCIDENTE SE ENCONTRABA ${formDatoSiniestro.AlMomentoDelAccidente.toUpperCase()}, LO QUE OCURRIÓ FUE ${formDatoSiniestro.CausaAccidente.toUpperCase()}, SE LESIONÓ CON ${formDatoSiniestro.Agente.toUpperCase()}, LA LESIÓN QUE PRESENTA ES ${formDatoSiniestro.Consecuencia.toUpperCase()}, LA ZONA LESIONADA ES ${formDatoSiniestro.ZonaAfectada.toUpperCase()}, ${formDatoSiniestro.Testigos === "X" ? `EL NOMBRE Y CARGO DEL TESTIGO ES ${formDatoSiniestro.DatosTestigo}` : "NO TIENE TESTIGOS DE SU ACCIDENTE"}, ${formDatoSiniestro.Aviso === "X" ? "" : "NO"} AVISÓ A LA EMPRESA ${formDatoSiniestro.Aviso === "X" ? `, EL NOMBRE Y CARGO DE LA PRESONA ES ${formDatoSiniestro.NombreCargoPersonaAviso.toUpperCase()} FECHA Y HORA EN QUE AVISÓ A SU EMPRESA SOBRE EL ACCIDENTE ${moment(formDatoSiniestro.FechaHoraAviso).format("DD-MM-YYYY [A LAS] HH:mm")}` : ""}`
    }
    this.props.dispatch(setDataNewComplain(jsonData));
  }

  handleBack = () => {
    this.props.dispatch(lastStep());
  }

  render() {
    const {
      formDatosEmpresa, formInfoTrabajador, formDatoSiniestro,
      formDenunciante, formInfoDenuncia, formDatosEnfermedad, horaPresentacion,
    } = { ...this.props.jsonData };
    return (
      <React.Fragment>
        <div className="col-12 newDenuncia-title">
          <h2>Enviar denuncia</h2>
          <p>Revisa los campos para verificar que todos los datos son correctos</p>
        </div>

        <div className="col-12">
          <h4 className="newDenuncia-subtitle">Identificación de la denuncia</h4>
          <div className="row zero-vertical">
            <div className="col-6 zero-right">
              <DateField
                label="Fecha de la denuncia"
                value={horaPresentacion}
                disabled
                type="date"
              />
            </div>
            <div className="col-6">
              <DateField
                label="Hora de la denuncia"
                value={horaPresentacion}
                disabled
                type="time"
              />
            </div>
          </div>
        </div>

        <div className="col-12">
          <h4 className="newDenuncia-subtitle">Identificación del empleador</h4>
          <div className="row zero-vertical">
            <div className="col-6 zero-right">
              <TextField
                label="Nombre o razón social"
                disabled
                value={formDatosEmpresa.NombreRazon}
              />
            </div>
            <div className="col-6">
              <TextField
                label="Rut"
                disabled
                value={formDatosEmpresa.RutEmpresa}
              />
            </div>

            <div className="col-6 zero-right">
              <TextField
                label="Actividad económica"
                disabled
                value={formDatosEmpresa.Actividad.DescripcionActividadEconomica}
              />
            </div>

            <div className="col-6">
              <TextField
                label="Tipo de empresa"
                value={formDatosEmpresa.TipoEmpresa.DescripcionTipoEmpresa}
                disabled
              />

            </div>
          </div>

          {formDatosEmpresa.TipoEmpresa
            && formDatosEmpresa.TipoEmpresa.IdTipoEmpresa !== 1
            && (
              <TextField
                label="Actividad económica principal de la empresa"
                value={formDatosEmpresa.ActividadPrincipal.DescripcionActividadEconomica}
                disabled
              />
            )}

          <TextField
            label="Propiedad de la empresa"
            value={formDatosEmpresa.Propiedad.DescripcionPropiedadEmpresa}
            disabled
          />
        </div>

        <div className="col-12">
          <h4 className="newDenuncia-subtitle">Identificación del trabajador</h4>

          <div className="row zero-vertical">
            <div className="col-7 zero-right">
              <TextField
                label="Nombre"
                disabled
                value={`${formInfoTrabajador.FirstName} ${formInfoTrabajador.LastName} ${formInfoTrabajador.MothersName}`}
              />
            </div>
            <div className="col-5">
              <TextField
                label="Rut"
                disabled
                value={formInfoTrabajador.Rut}
              />
            </div>

            <div className="col-4 zero-right">
              <TextField
                label="Sexo"
                disabled
                value={formInfoTrabajador.Sexo.Sexo}
              />
            </div>
            <div className="col-3 zero-right">
              <TextField
                disabled
                label="Edad"
                value={calculateAge(formInfoTrabajador.Birthdate)}
              />
            </div>
            <div className="col-5">
              <TextField
                label="Fecha de nacimiento"
                value={formatDateForFormDenuncia(formInfoTrabajador.Birthdate)}
                disabled
              />
            </div>

            <div className="col-7 zero-right">
              <TextField
                label="Dirección particular"
                value={`${formInfoTrabajador.Calle}, ${formInfoTrabajador.Numero}. ${formInfoTrabajador.Poblacion || ""}`}
                disabled
              />
            </div>
            <div className="col-5">
              <TextField
                label="Comuna"
                disabled
                value={formInfoTrabajador.Comuna.DescripcionCommuna}
              />
            </div>

            <div className="col-4 zero-right">
              <TextField
                label="Teléfono"
                value={`${formInfoTrabajador.Code && formInfoTrabajador.Phone ? formInfoTrabajador.Code : "-"} ${formInfoTrabajador.Code && formInfoTrabajador.Phone ? formInfoTrabajador.Phone : "-"}`}
                disabled
              />
            </div>
            <div className="col-3 zero-right">
              <TextField
                label="Nacionalidad"
                value={formInfoTrabajador.Nacionalidad.Nacionalidad}
                disabled
              />
            </div>
            <div className="col-5">
              <TextField
                label="Pueblo originario"
                value={formInfoTrabajador.PuebloOriginario.PuebloOriginario}
                disabled
              />
            </div>

            <div className="col-4 zero-right">
              <TextField
                label="Profesión/Oficio"
                value={formInfoTrabajador.ProfesionOficio.Ocupacion}
                disabled
              />
            </div>
            <div className="col-4 zero-right">
              <TextField
                label="Tipo de contrato"
                value={formInfoTrabajador.TipoContrato.TipoContrato}
                disabled
              />
            </div>
            <div className="col-4">
              <TextField
                label="Antigüedad"
                value={calculateAgeDays(formInfoTrabajador.Antiguedad)}
                disabled
              />
            </div>

            <div className="col-6">
              <TextField
                label="Tipo de ingreso"
                value={formInfoTrabajador.TipoIngreso.TipoIngreso}
                disabled
              />
            </div>
            <div className="col-6 zero-left">
              <TextField
                label="Categoria ocupacional"
                value={formInfoTrabajador.CategoriaOcupacional.CategoriaOcupacional}
                disabled
              />
            </div>

          </div>
        </div>

        {formInfoDenuncia.tipoDenuncia.IdTipoDenuncia === "003" ?
          <React.Fragment>
            <div className="col-12">
              <h4 className="newDenuncia-subtitle">Datos del accidente</h4>

              <TextField
                disabled
                label="Tipo de accidente"
                value={formDatoSiniestro.TipoAccidente.DescripcionTipoAccidente}
              />

              {formDatoSiniestro.TipoAccidente.IdTipoAccidente === 2 &&
                <TextField
                  label="Tipo de accidente de trayecto"
                  disabled
                  value={formDatoSiniestro.TipoAccidenteTrayecto.DescripcionTipoAccidenteTrayecto}
                />
              }

              {/* <RadioGroupfield
                label="En condiciones ligeramente diferentes ¿Usted cree que este accidente pudo haber sido más grave o fatal?"
                items={[{ text: "Si", value: "X" }, { text: "No", value: "N" }]}
                layout="horizontal"
                displayExpr="text"
                valueExpr="value"
                value={formDatoSiniestro.CondicionesAccidente}
                disabled
              /> */}

              {/* {formDatoSiniestro.CondicionesAccidente === "X" && */}
              <TextField
                label="Clasificación del accidente (grado)"
                value={formDatoSiniestro.ClasificacionAccidente ? formDatoSiniestro.ClasificacionAccidente.ClasificacionAccidente : null}
                disabled
              />
              {/* } */}

              <DateField
                label="Fecha y hora del accidente"
                value={formDatoSiniestro.FechaHoraAccidente}
                disabled
                type="datetime"
              />

              <TextField
                label="Sitio preciso del accidente"
                value={formDatoSiniestro.SitioAccidente}
                disabled
              />

              <TextField
                label="Trabajo habitual del trabajador"
                value={formDatoSiniestro.TrabajoHabitual}
                disabled
              />

              <TextField
                label="Actividad realizada antes del accidente"
                value={formDatoSiniestro.ActividadAntesAccidente}
                disabled
              />

              <div className="field-newDenuncia">
                <h3><p>Describa ¿Qué pasó o cómo ocurrió el accidente?</p></h3>
                <TextArea
                  disabled
                  height={200}
                  value={formDatoSiniestro.textoCircunstacia}
                />
              </div>

              <RadioGroupfield
                label="¿Al momento del accidente realizaba su trabajo habitual?"
                items={[{ text: "Si", value: "X" }, { text: "No", value: "N" }]}
                layout="horizontal"
                value={formDatoSiniestro.RealizabaSuTrabajo}
                displayExpr="text"
                valueExpr="value"
                disabled
              />

              {/* {formDatoSiniestro.Testigos && formDatoSiniestro.Testigos === "X" &&
                <TextField
                  id="DatosTestigo"
                  label="El nombre y cargo del testigo es"
                  value={formDatoSiniestro.DatosTestigo}
                  disabled
                />
              } */}

            </div>

            <div className="col-12">
              <h4 className="newDenuncia-subtitle">Medios de prueba</h4>

              <TextField
                label="Medio de prueba"
                disabled
                value={formDatoSiniestro.MedioPrueba && formDatoSiniestro.MedioPrueba.MedioPrueba}
              />

              <TextField
                label="Detalle del medio de prueba"
                disabled
                value={formDatoSiniestro.DetalleMedioPrueba}
              />
            </div>
          </React.Fragment>
          :
          <div className="col-12">
            <h4 className="newDenuncia-subtitle">Datos de la enfermedad</h4>

            <TextField
              label="Describa las molestias o síntomas que actualmente tiene el trabajador"
              value={formDatosEnfermedad.DescripcionSintomas}
              disabled
            />
            <TextField
              label="¿Hace cuánto tiempo tiene estas molestias o síntomas?"
              value={formatDateForFormDenuncia(formDatosEnfermedad.FechaInicioSintomas)}
              disabled
            />
            <TextField
              label="¿Había tenido estas molestias en el puesto de trabajo actual, anteriormente?"
              disabled
              value={formDatosEnfermedad.CuadroPrevio === "X" ? "Sí" : "No"}
            />
            <TextField
              label="Partes del cuerpo afectada"
              disabled
              value={formDatosEnfermedad.PartesCuerpo}
            />
            <TextField
              label="Describa el trabajo o actividad que realizaba cuando comenzaron las molestias"
              disabled
              value={formDatosEnfermedad.DescripcionTrabajo}
            />
            <TextField
              label="Nombre del puesto de trabajo o actividad que realizaba cuando comenzaron las molestias"
              disabled
              value={formDatosEnfermedad.NombrePuesto}
            />
            <TextField
              label="¿Existen compañeros de trabajo con las mismas molestias?"
              disabled
              value={formDatosEnfermedad.ExistenCompanerosSintomas === "X" ? "Sí" : "No"}
            />
            <TextField
              label="¿Qué cosas o agentes de trabajo cree usted que le causan estas molestias?"
              disabled
              value={formDatosEnfermedad.Agente}
            />
            <TextField
              label="¿Cuánto tiempo ha estado expuesto o trabajando con estas cosas o agentes del trabajo?"
              disabled
              value={formatDateForFormDenuncia(formDatosEnfermedad.FechaPrimeraExposicion)}
            />
          </div>
        }

        <div className="col-12">
          <h4 className="newDenuncia-subtitle">Identificación del denunciante</h4>
          <div className="row zero-vertical">
            <div className="col-8 zero-right">
              <TextField
                label="Nombre"
                disabled
                value={`${formDenunciante.FirstName} ${formDenunciante.LastName} ${formDenunciante.MothersName}`}
              />
            </div>
            <div className="col-4">
              <TextField
                label="Rut"
                disabled
                value={formDenunciante.Rut}
              />
            </div>

            <div className="col-8 zero-right">
              <TextField
                label="Clasificación del denunciante (ley 16.744)"
                value="Empresa"
                disabled
              />
            </div>
            <div className="col-4">
              <TextField
                label="Teléfono"
                value={formDenunciante.Phone}
                disabled
              />
            </div>
          </div>

          <TextField
            disabled
            label="Firma del denunciante"
          />
        </div>


        <div className="col-12">
          <h3>
            <p style={{ textAlign: "justify" }}>
              La simulación de un accidente del trabajo puede ser sancionada
              y da lugar al cobro de las prestaciones indebidamente obtenidas.
              Ello conforme a lo establecido al efecto por el artículo 43 de la ley N° 12.084,
              el que dispone que “Incurrirán en las penas establecidas en el artículo 210 del Código Penal,
              los que hicieren declaraciones falsas en certificados de supervivencia,
              de estado civil y demás que se exigen para el otorgamiento de beneficios de previsión.”
            </p>
          </h3>
          <Button text="Volver" className="newDenuncia-back-button" onClick={this.handleBack} />
          {/* <Button
            text="Ver PDF"
            style={{ marginLeft: 10, marginTop: 20 }}
            onClick={() => {
              this.props.dispatch(VerPDF(this.props.jsonData));
            }}
          /> */}

          <Button
            text="Enviar"
            type="success"
            className="newDenuncia-next-button"
            onClick={() => {
              this.props.dispatch(doCreateComplaints(this.props.jsonData));
            }}
          />
        </div>
      </React.Fragment >
    );
  }
}
const mapStateToProps = (state) => ({
  UserInfo: state.userRegister.UserInfo,
  jsonData: state.denuncias.jsonData,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(EnvioDenuncia);
